import './modules/register-service-worker';
import '@crasman/branch-bar/styles.css';
import gtm from './modules/gtm';
import { branchBar } from '@crasman/branch-bar';

gtm.init();

if (document.querySelector('.mobile-menu')){
  import(/* webpackChunkName: "mobile-menu-js", webpackMode: "lazy" */'./modules/mobile-menu').then(m => { // jshint ignore:line
    m.default.init();
  });
}

if(document.querySelector('.accordion')){
  import(/* webpackChunkName: "accordion-css", webpackMode: "lazy" */'./../scss/elements/_accordion.scss'); // jshint ignore:line
  import(/* webpackChunkName: "accordion-js", webpackMode: "lazy" */'./modules/accordion').then(m => { // jshint ignore:line
    m.default.init();
  });
}

if(document.querySelector('.video-overlay')){
  import(/* webpackChunkName: "video-overlay-js", webpackMode: "lazy" */'./modules/video-overlay').then(m => { // jshint ignore:line
    m.default.init();
  });
}

if (document.querySelector('.accordions')){
  import(/* webpackChunkName: "accordions-css", webpackMode: "lazy" */'./../scss/elements/_accordions.scss'); // jshint ignore:line
}

if (document.querySelector('.blocks-5050')){
  import(/* webpackChunkName: "blocks-5050-css", webpackMode: "lazy" */'./../scss/elements/_blocks-5050.scss'); // jshint ignore:line
}

if (document.querySelector('.card-columns')){
  import(/* webpackChunkName: "card-columns-css", webpackMode: "lazy" */'./../scss/elements/_card-columns.scss'); // jshint ignore:line
}

if (document.querySelector('.cta-box')){
  import(/* webpackChunkName: "cta-box-css", webpackMode: "lazy" */'./../scss/elements/_cta-box.scss'); // jshint ignore:line
}

if (document.querySelector('.faq-list')){
  import(/* webpackChunkName: "faq-list-css", webpackMode: "lazy" */'./../scss/elements/_faq-list.scss'); // jshint ignore:line
}

if (document.querySelector('.grid-boxes')){
  import(/* webpackChunkName: "grid-boxes-css", webpackMode: "lazy" */'./../scss/elements/_grid-boxes.scss'); // jshint ignore:line
}

if (document.querySelector('.image-columns')){
  import(/* webpackChunkName: "image-columns-css", webpackMode: "lazy" */'./../scss/elements/_image-columns.scss'); // jshint ignore:line
}

if(document.querySelector('.login')){
  import(/* webpackChunkName: "login-css", webpackMode: "lazy" */'./../scss/elements/_login.scss'); // jshint ignore:line
}

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();
